import {useCallback} from 'react'
import {msg} from '@lingui/core/macro'
import {useLingui} from '@lingui/react'

import {logger} from '#/logger'
import {useVerificationsRemoveMutation} from '#/state/queries/verification/useVerificationsRemoveMutation'
import {type DialogControlProps} from '#/components/Dialog'
import * as Prompt from '#/components/Prompt'
import * as Toast from '#/components/Toast'
import {type app} from '#/lexicons'
import type * as bsky from '#/types/bsky'

export {useDialogControl as usePromptControl} from '#/components/Dialog'

export function VerificationRemovePrompt({
  control,
  profile,
  verifications,
  onConfirm: onConfirmInner,
}: {
  control: DialogControlProps
  profile: bsky.profile.AnyProfileView
  verifications: app.bsky.actor.defs.VerificationView[]
  onConfirm?: () => void
}) {
  const {_} = useLingui()
  const {mutateAsync: remove} = useVerificationsRemoveMutation()
  const onConfirm = useCallback(async () => {
    onConfirmInner?.()
    try {
      await remove({profile, verifications})
      Toast.show(_(msg`Removed verification`))
    } catch (e) {
      Toast.show(_(msg`Failed to remove verification`), {
        type: 'error',
      })
      logger.error('Failed to remove verification', {
        safeMessage: e,
      })
    }
  }, [_, profile, verifications, remove, onConfirmInner])

  return (
    <Prompt.Basic
      control={control}
      title={_(msg`Remove your verification for this account?`)}
      onConfirm={onConfirm}
      confirmButtonCta={_(msg`Remove verification`)}
      confirmButtonColor="negative"
    />
  )
}
